import type { Stay, Nullable } from '@shared/types/utils';

import stayLength from '@shared/utils-universal/guest-stay/stay-length';
import { isPerNightPriceType } from '@shared/utils-universal/price-type';

const secondaryCurrencies = [
  'ALL',
  'BIF',
  'CLP',
  'DJF',
  'GNF',
  'IRR',
  'JPY',
  'KMF',
  'KPW',
  'KRW',
  'MGA',
  'PYG',
  'RWF',
  'VND',
  'VUV',
  'XAF',
  'XOF',
  'XPF',
];

const priceChangeThreshold = (currency: string) => {
  if (secondaryCurrencies.includes(currency)) {
    return 100;
  }
  return 5;
};

const priceChangeDiff = (
  dayviewPrice: Nullable<number>,
  detailPrice: number,
  stay: Stay,
  priceType: Nullable<string>,
) => {
  if (dayviewPrice) {
    const { checkIn, checkOut } = stay;
    const priceDiff = dayviewPrice - detailPrice;

    const numberOfNights = stayLength({ checkIn, checkOut });
    if (numberOfNights === 1) {
      return priceDiff;
    }

    if (priceType && isPerNightPriceType(priceType)) {
      return priceDiff;
    }

    return Math.ceil(priceDiff / numberOfNights);
  }
  return 0;
};

export { priceChangeThreshold, priceChangeDiff };
